// extracted by mini-css-extract-plugin
export default {"preview":"style--preview--972b91"};